import React from "react";
import { useTenantBranding } from "../../../shared/branding/TenantBrandingProvider";
import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  const { branding } = useTenantBranding();
  const appName = branding?.company_name || "MGuseva CRM";

  return (
    <main className="privacy-page">
      <article className="privacy-card">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last updated: September 28, 2026</p>

        <p>
          This Privacy Policy explains how {appName} processes information when
          you use this website and its CRM features, including the optional
          Google Drive integration.
        </p>

        <h2>Information we process</h2>
        <p>
          The service may process account and contact information, CRM records,
          files and photos that users choose to upload, and technical data
          required to operate and secure the service.
        </p>

        <h2>Google Drive integration</h2>
        <p>
          If you choose to connect Google Drive, the application requests the
          Google Drive file permission needed to create, view, update, and
          delete files that the application uses or creates. The application
          does not request access to all files in your Google Drive.
        </p>
        <p>
          Google account authorization tokens are used only to provide the
          requested Drive integration. Google user data is not sold or used for
          advertising.
        </p>

        <h2>How information is used</h2>
        <p>
          Information is used to provide CRM functionality, store and manage
          user-requested files, maintain security, troubleshoot the service,
          and comply with applicable legal obligations.
        </p>

        <h2>Data sharing</h2>
        <p>
          We do not sell personal information. Information is shared only with
          service providers required to operate the service, when instructed by
          the user, or when required by law.
        </p>

        <h2>Data retention and deletion</h2>
        <p>
          Data is retained only as long as needed to provide the service or meet
          legal obligations. Users can disconnect Google Drive at any time and
          may request deletion of their stored application data by contacting us.
        </p>

        <h2>Security</h2>
        <p>
          Reasonable technical and organisational safeguards are used to protect
          information against unauthorised access, alteration, disclosure, or
          loss.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy questions or deletion requests, contact:{" "}
          <a href="mailto:mguseva.nails@gmail.com">mguseva.nails@gmail.com</a>
        </p>
      </article>
    </main>
  );
}
